import { useConversionTracker } from './useConversionTracker';
import { defaultConversionRegistry } from './conversions';

export function useDefaultConversionTracker() {
  return useConversionTracker(defaultConversionRegistry);
}
